import { render, staticRenderFns } from "./addVote.vue?vue&type=template&id=06960b02&scoped=true&"
import script from "./addVote.vue?vue&type=script&lang=js&"
export * from "./addVote.vue?vue&type=script&lang=js&"
import style0 from "./addVote.vue?vue&type=style&index=0&id=06960b02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06960b02",
  null
  
)

export default component.exports